<template>
  <div>
    <d-modal v-if="artistsModal" @close="artistsModal = false">
      <d-modal-header>
        
      </d-modal-header>
      <d-modal-body>
        <d-input v-model="searchArtist" autofocus />
        <div
          v-for="(a, i) in filteredArtists"
          :key="i"
          @click="addArtistToEvent(a)"
          class="artist"
        >{{a.name}}</div>
      </d-modal-body>
    </d-modal>    

    <b-modal
      v-if='addEventModal'
      v-model='addEventModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddScene()'
      centered
      size="lg"
    >
      <b-row>
        <b-col cols="6" class='mb-3'>
          <label>Artysta</label>
          <d-btn
            theme="light"
            size="sm"
            @click.prevent.stop="openArtistModal()"
          >{{ activeArtist == null ? 'Wybierz' : activeArtist.name }}</d-btn>
        </b-col>
        <b-col cols="6" class='mb-3'>
          <label>Nazwa wyświetlana</label>
          <b-form-input
            v-model="name.pl"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" class='mb-3'>
          <label>Data od</label>
          <datetime
            type="datetime"
            input-class="form-control form-control-sm"
            :value="dateFrom"
            value-zone="local"
            :minute-step="5"
            format="HH:mm"
            @input='(e) => { dateFrom = e }'
          />
        </b-col>
        <b-col cols="6" class='mb-3'>
          <label>Data do</label>
          <datetime
            type="datetime"
            input-class="form-control form-control-sm"
            :value="dateTo"
            value-zone="local"
            :minute-step="5"
            format="HH:mm"
            @input='(e) => { dateTo = e }'
          />
        </b-col>
      </b-row>  
    </b-modal>

    <b-row style="border-bottom: 1px solid #007bff;" class="mr-0">
      <b-col cols="3" class="pl-0" style="display: flex;">
        <b-icon-calendar class="mr-2" style="margin-top: 3px" variant="primary" />
        <label class="h6">{{ date }}</label>
      </b-col>
      <b-col cols="3">
        <label class="h6">{{ namePl }}</label>
      </b-col>
      <b-col cols="3">
        <label class="h6">{{ nameEn }}</label>
      </b-col>
      <b-col cols="3" class="pr-0">
        <b-button variant='outline-primary' class="float-right mb-1" size='sm' @click='handleAddEvent'>Dodaj wydarzenie</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="pt-2 mb-3">
        <artists :day='day' :scene='scene' />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {
    BIconTrash,
    BIconPencil,
    BIconCalendar,
    BIconPlus,
  } from 'bootstrap-vue'

  import Artists from './Artists'

  import {
    handleAddEventToScene
  } from '@/store/utils'

  export default {
    props: ['day', 'scene'],
    components: {
      BIconTrash,
      BIconPencil,
      BIconCalendar,
      BIconPlus,
      Artists,
    },
    data() {
      return {
        addEventModal: false,
        artistsModal: false,
        name: { pl: '', en: '' },
        dateFrom: null,
        dateTo: null,
        activeArtist: null,
        searchArtist: "",
        actions: {
          handleAddEventToScene
        },
      }
    },
    computed: {
      date() {
        return this.day.date.slice(0, 10);
      },
      namePl() {
        return this.day.name.pl;
      },
      nameEn() {
        return this.day.name.en;
      },
      filteredArtists() {
        return this.searchArtist == ""
        ? []
        : this.$store.state.artists.all.filter(
            a =>
              a.name.toLowerCase().indexOf(this.searchArtist.toLowerCase()) > -1 &&
              a.fanzine_id === this.$store.state.fanzones.form.id
          );
    }
    },
    methods : {
      handleAddEvent() {
        this.actions.handleAddEventToScene(this.scene, this.day)
      },
      openArtistModal() {
        //this.activeArtist = e;
        this.artistsModal = true;
      },
    },
  }
</script>

